import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";
import moment from "moment";

function UpdatePlanModal({
  open = false,
  onCancel = () => {},
  data = {},
  onSuccess = () => {},
}) {
  const [plans, setPlans] = useState([]);

  const fetchPlans = async () => {
    const res = await apiRequest({
      path: apiPaths.subscriptionPlans + "?show_all=true",
    });
    if (!res.error) {
      setPlans(res.results);
    } else {
      message.error(res.error_description);
    }
  };

  const handleUpdateUserPlan = async (values) => {
    values.plan = values.plan.value;
    const res = await apiRequest({
      path: apiPaths.userPlans + `/${data.id}`,
      method: "PUT",
      data: values,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    message.success("Updated user plan");
    onSuccess(res);
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  return (
    <Modal
      title={"Update User Plan"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        initialValues={{
          ...data,
          start_time: moment(data.start_time),
          end_time: moment(data.end_time),
          plan: { value: data.plan.id, label: data.plan.name, ...data.plan },
          note: "",
        }}
        onFinish={handleUpdateUserPlan}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Plan (Validity)"
              name={"plan"}
              rules={[
                {
                  required: true,
                  message: `Please select plan!`,
                },
              ]}
            >
              <Select
                placeholder={"Select plan"}
                style={{ width: 280 }}
                labelInValue={true}
              >
                {plans.map((item, index) =>
                  item.validity ? (
                    <Select.Option key={index + "o"} value={item.id}>
                      {item.name + ` (${item.validity} days)`}
                    </Select.Option>
                  ) : null
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Expiry"
              name="remove"
              valuePropName="checked"
              tooltip="This will update the plan to expired date"
            >
              <Checkbox>Remove Plan</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Plan Start Date"
              name="start_time"
              rules={[
                {
                  required: true,
                  message: "Please select Plan Start Date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "60%" }}
                placeholder="Select Start Date"
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Plan End Date"
              name="end_time"
              rules={[
                {
                  required: true,
                  message: "Please select Plan End Date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "60%" }}
                placeholder="Select End Date"
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={18}>
            <Form.Item
              label="Note"
              name="note"
              rules={[
                {
                  required: true,
                  message: "Please enter note",
                },
              ]}
            >
              <Input.TextArea rows={4} placeholder="Eg: why this update..." />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Update"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default UpdatePlanModal;
